import { useEffect, useState } from 'react'
import useSWR from 'swr'
import { getUserCountry } from '@/apis/user'

const USER_COUNTRY_SWR_KEY = '/user/country'

const useUserLocation = () => {
  const [platform, setPlatform] = useState<'iOS' | 'Android' | 'Other'>()
  const { data: country = '' } = useSWR(USER_COUNTRY_SWR_KEY, getUserCountry, {
    dedupingInterval: 8_000,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    onError: (error: unknown) => {
      console.error('Failed to fetch user country:', error)
    },
  })

  useEffect(() => {
    const getMobileOS = () => {
      const ua = navigator.userAgent

      if (/android/i.test(ua)) return 'Android'
      if (/iPad|iPhone|iPod/.test(ua)) return 'iOS'
      return 'Other'
    }

    setPlatform(getMobileOS())
  }, [])

  return { country, platform }
}

export default useUserLocation
